module.exports = __webpack_public_path__ + "static/TOYOTA_ACT_3_CUSTOM_SPOT_ALONE-92f7351123517b0acb1dd9da4d7a3b6c.mp4";